// Above the header (1000), floating action buttons (9998) and Preline overlays (99999).
export const MODAL_Z_INDEX = 999999;
export const MODAL_BACKDROP_COLOUR = "rgba(0, 0, 0, 0.65)";
